var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"acomodar"},[(_vm.Spinner)?_c('SpinnerCarga',{staticClass:"container"}):_c('RenovacionesMasivo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }